const SITE_DOMAIN = "hearthvault.family";
const VERIFY_URL = `https://www.sitelock.com/verify.php?site=${SITE_DOMAIN}`;

export const SiteLockSeal = ({ className = "" }) => {
  const openVerify = (e) => {
    e.preventDefault();
    window.open(VERIFY_URL, "SiteLock", "width=600,height=600,left=160,top=170");
  };
  return (
    <a href={VERIFY_URL} onClick={openVerify} target="_blank" rel="noopener noreferrer" aria-label="Verified by SiteLock — click to view verification" title="SiteLock" data-testid="sitelock-seal" className={`inline-flex items-center opacity-90 hover:opacity-100 transition-opacity ${className}`}>
      <img src={`https://shield.sitelock.com/shield/${SITE_DOMAIN}`} alt="SiteLock" width="120" height="40" loading="lazy" className="h-9 w-auto" />
    </a>
  );
};
